/**
 * Oracle sync observability contract — what `GET /api/admin/sync` returns and the SPA renders.
 * Mirrors the `sync_run` / `sync_watermark` ledgers written by @erp-attach/functions (spec §7).
 */
export const SYNC_RUN_STATUSES = ['running', 'success', 'failed'];
/** Known `sync_run.source` values, in the order the UI lists them. Unknown sources are appended. */
export const SYNC_SOURCES = ['customers', 'sites', 'suppliers', 'user-roles', 'reconcile', 'audit-export'];
/** Spec §7: alert when the sync lag exceeds one hour. */
export const SYNC_LAG_WARN_MS = 60 * 60 * 1000;
//# sourceMappingURL=sync.js.map